import { CellAction } from "./cell-action";

import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },
  {
    accessorKey: "category",
    header: "CATÉGORIE",
  },

  {
    accessorKey: "description",
    header: "DESCRIPTION",
    cell: ({ row }) => {
      const message = row.original.description;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = message;
      const plainText = tempDiv.textContent || tempDiv.innerText || "";
      return plainText.length > 10 ? `${plainText.slice(0, 10)}...` : plainText;
    },
  },

  {
    accessorKey: "date",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.date);
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
